import cookies from 'js-cookie';
import router from '@/router';

import { handleLogin, handleFbLogin } from '@/store/api/login';
import { handleSignUp } from '@/store/api/signUp';
import { handleFetchUserProfile, handleUpdateUser, handleUpdatePassword } from '@/store/api/user';

const state = {
  currentUser: null,
  loginError: '',
  signUpError: {},
  updateError: '',
  userProfile: null,
  userProfileError: ''
};

const getters = {
  currentUser: ({ currentUser }) => {
    return currentUser;
  },

  loginError: ({ loginError }) => {
    return loginError;
  },

  signUpError: ({ signUpError }) => {
    return signUpError;
  },

  updateError: ({ updateError }) => {
    return updateError;
  },

  userProfile: ({ userProfile }) => {
    return userProfile;
  },

  userProfileError: ({ userProfileError }) => {
    return userProfileError;
  },
};

const actions = {
  async handleFbLogin({ commit }, payload) {
    const newPayload = {
      access_token: payload['authResponse']['accessToken'],
      uid: payload['authResponse']['userID']
    };

    const { message, jwt, user } = await handleFbLogin(newPayload);

    if (message) {
      commit('SAVE_LOGIN_ERROR', message);
    } else {
      commit('SAVE_LOGIN_ERROR', '');
      commit('SAVE_CURRENT_USER', user);
      commit('UPDATE_AUTHENTICATED', true);

      router.push({
        name: 'DiscoverCapsules'
      });
    }
  },

  async fetchUserProfile({ commit }, username) {
    const { data } = await handleFetchUserProfile(username);

    if (data) {
      commit('SAVE_USER_PROFILE', data['user']);
      commit('SAVE_USER_PROFILE_ERROR', '');
    } else {
      commit('SAVE_USER_PROFILE_ERROR', `Unable to fetch ${username}'s profile`);
    }
  },

  async handleLogin({ commit }, payload) {
    const { message, jwt, user } = await handleLogin(payload);

    if (message) {
      commit('SAVE_LOGIN_ERROR', 'Invalid email or password');
    } else {
      commit('SAVE_LOGIN_ERROR', '');
      commit('SAVE_CURRENT_USER', user);
      commit('UPDATE_AUTHENTICATED', true);

      router.push({
        name: 'DiscoverCapsules'
      });
    }
  },

  changeUserCapsuleCount({ commit, state }, direction) {
    let value = state.currentUser.capsule_count

    if (direction === 'increment') {
      value += 1
    } else if (direction === 'decrement') {
      if (value > 0) value -= 1
    }

    commit('UPDATE_CURRENT_USER_CAPSULE_COUNT', value);
  },

  logoutUser({ commit }) {
    cookies.remove('_us_token');
    cookies.remove('_us_user');

    commit('SAVE_CURRENT_USER', null);
  },

  async handleSignUp({ commit, dispatch }, payload) {
    const { errors } = await handleSignUp(payload);

    if (errors) {
      commit('SAVE_SIGN_UP_ERROR', errors);
    } else {
      commit("SAVE_SIGN_UP_ERROR", {});

      const authPayload = {
        'auth': {
          'email': payload.user.email,
          'password': payload.user.password
        }
      };

      dispatch('handleLogin', authPayload);
    }
  },

  async handleUpdateUserDetails({ commit }, payload) {
    const userId = payload['userId'];
    const formData = payload['formData'];

    const { user, message } = await handleUpdateUser(userId, formData);

    if (message) {
      commit('SAVE_UPDATE_ERROR', message);
    } else {
      cookies.remove('_us_user');
      cookies.set('_us_user', user, { expires: 14 });

      commit('SAVE_UPDATE_ERROR', '');
      commit('SAVE_CURRENT_USER', user);
    }
  },

  async handleUpdateUserPassword({ commit }, payload) {
    const userId = payload['userId'];
    const formData = new FormData();

    formData.append('user[current_password]', payload['currentPassword']);
    formData.append('user[new_password]', payload['newPassword']);

    const { user, message } = await handleUpdatePassword(userId, formData);

    if (message) {
      commit('SAVE_UPDATE_ERROR', message);
    } else {
      commit('SAVE_UPDATE_ERROR', '');
    }
  },

  // TODO: If user finished tour but signs up/in after
  //       the cookie will be created but the param will
  //       not be set in the DB and will run again after
  //       cookie expires.
  async handleFinishFeatureTour({ dispatch }, payload) {
    const userId = payload['userId'];

    if (userId) {
      dispatch('handleUpdateUserDetails', payload);
    }

    const cookieName = `_unstitched_${payload['coachmarksPage']}_coachmarks`;
    cookies.set(cookieName, true, { expires: 14 });
  },
}

const mutations = {
  SAVE_CURRENT_USER(state, user) {
    state.currentUser = user;
  },

  SAVE_LOGIN_ERROR(state, message) {
    state.loginError = message;
  },

  SAVE_SIGN_UP_ERROR(state, message) {
    state.signUpError = message;
  },

  SAVE_UPDATE_ERROR(state, message) {
    state.updateError = message;
  },

  SAVE_USER_PROFILE(state, user) {
    state.userProfile = user;
  },

  SAVE_USER_PROFILE_ERROR(state, message) {
    state.userProfileError = message;
  },

  UPDATE_CURRENT_USER_CAPSULE_COUNT(state, value) {
    state.currentUser.capsule_count = value;

    cookies.remove('_us_user');
    cookies.set('_us_user', state.currentUser, { expires: 14 });
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js